export default __webpack_public_path__ + "static/media/graph-up.990554e8.svg";